module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#pdf",
      toString: function () {
        return this.url;
      }
    }